import { useState, useCallback, useEffect } from 'react';

export const useApiService = (selectedApis) => {
  const [availableAgents, setAvailableAgents] = useState([]);

  const API_URLS = {
    orchestrator: process.env.REACT_APP_AUTH_BACKEND_URL,
  };

  const API_URL = API_URLS[selectedApis] || API_URLS.orchestrator;

  const fetchAvailableAgents = useCallback(async () => {
    try {
      const response = await fetch(
          `${API_URL}/list_agents`,
          { credentials: 'include' }
      );
      if (response.ok) {
        const data = await response.json();
        setAvailableAgents(data.agents || []);
      }
    } catch (error) {
      console.error("Failed to fetch available agents:", error);
      setAvailableAgents([]);
    }
  }, [API_URL]);

  useEffect(() => {
      void fetchAvailableAgents();
  }, [fetchAvailableAgents]);

  return { API_URL, availableAgents, fetchAvailableAgents };
};
